import { GENDER } from '../schemas/common';
import { ORDER_STATUS, PRODUCT_TYPE } from '../schemas/order';
import { IPickerOption } from '../schemas/register';

export const RESPONSE_SUCCESS_CODE = 0;
export const RESPONSE_REDIRECT_STATUS = 401;
export const RESPONSE_LOGIN_TIMEOUT = 109;
// 网络请求提示消息
export const REPONSE_ERROR_MSG = '接口请求失败，请稍后重试';

/**
 * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
 *
 * @type boolean
 */
export const deviceIsWindowsPhone =
  navigator.userAgent.indexOf('Windows Phone') >= 0;

/**
 * iOS requires exceptions.
 *
 * @type boolean
 */
export const deviceIsIOS =
  /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;

/**
 * 协议内容
 * TODO 待补充
 */
export const Protocol =
  '欢迎您使用快手健康频道服务。 我们将依据《快手健康频道用户协议》及《快手健康隐私权保护政策》来帮助您了解我们在收集、使用、储存和共享您个人信息的情况以及您享有的相关权利。 在您通过快手健康频道进行视频、图片等内容的浏览时，我们需要收集您的设备信息。 为了向您提供更切合您需求的页面、视频等内容，我们需要收集您的搜索记录和点击记录、您浏览过的内容等有关的网络日志信息。 在您使用快手健康频道上传视频、进行评论等服务时，我们可能会通过弹窗方式向您请求授权相机、照片权限。 您可以在相关页面访问、修改、删除您的个人信息或管理您的授权。 我们会采用行业内领先的安全技术来保护好您的个人信息。 您可以通过阅读完整的《快手健康频道用户协议》及《快手健康隐私权保护政策》 来了解详细信息。';

export const DOCTOR_NOT_ONLINE = '当前医生不在线，请选择其他医生进行咨询';

// 隐私协议
export const PrivacyProtocolUrl =
  'https://s2-10604.kwimgs.com/kos/nlav10604/protocol/privacy_protocol_20210916.html';

// 用户协议
export const UserProtocolUrl =
  'https://s2-10604.kwimgs.com/kos/nlav10604/protocol/user_protocol_20210916.html';

// 付费在线咨询风险告知及知情同意书
export const ConsultProtocolUrl =
  'https://s2-10604.kwimgs.com/kos/nlav10604/protocol/consult_protocol_20210916.html';

// 核酸检测 信息授权函
export const NucleicAcidTestingProtocolUrl =
  'https://s2-10604.kwimgs.com/kos/nlav10604/protocol/NucleicAcidTestingInformationAuthorizationLetter20210313.html';

// 挂号订单协议
export const RegisterProtocolUrl =
  'https://s2-10604.kwimgs.com/kos/nlav10604/protocol/register_agreement_20210627.html';

export const genderConfig = {
  [GENDER.Female]: '女',
  [GENDER.Male]: '男'
};

export const productTypeConfig = {
  // [PRODUCT_TYPE.Message]: '图文私信',
  // [PRODUCT_TYPE.Call]: '语音通话', // 一期无此功能
  [PRODUCT_TYPE.Free]: '免费咨询'
};

export const orderStatusConfig = {
  // [ORDER_STATUS.Initial]: {
  //   title: '待付款',
  //   tag: '待付款',
  //   tips: '请付款'
  // },
  [ORDER_STATUS.HasPaid]: {
    icon: 'waiting',
    tag: '未开始',
    userTips: '咨询未开始，请按时回复哦',
    doctorTips: '咨询未开始，请按时回复哦'
  },
  [ORDER_STATUS.Consulting]: {
    icon: 'consulting',
    tag: '进行中',
    userTips: '正在和医生沟通中，请注意医生回复',
    doctorTips: '沟通中，请及时回复'
  },
  [ORDER_STATUS.HasConsulted]: {
    icon: 'done',
    tag: '已结束',
    userTips: '咨询已结束，感谢您的使用',
    doctorTips: '咨询已结束，感谢您的使用'
  }
};

export const REFRESH_TIME = 60 * 1000; // 客服消息数量接口刷新频率

export const USER_REFRESH_TIME = 60 * 1000; // 医生与患者获取未读消息轮训间隔时间

// 快手健康官号快手号
export const HEALTH_OFFICIAL = '40300179';
// 关注白名单
export const FOLLOW_WHITE_LIST = 'P201215202000EQ';
// 快手粉条官号快手号
export const VERMICELLI_OFFICIAL = '40300047';

// 正式环境域名
export const HOST_PROD = 'https://healthy.kuaishou.com';
// export const HOST_PROD = 'http://health.corp.kuaishou.com:4200'; // test

// 健康主页地址
export const HOME_PAGE_URL = `kwai://webview?url=${encodeURIComponent(
  'https://healthy.kuaishou.com/?layoutType=4&enableWK=1'
)}`;

export const SOURCE_SEARCH = 'search';

export const SOURCE_JIMU = 'jimu';

// 付费咨询支付中台商户ID
export const ConsultInfo = {
  merchantId:
    process.env.NX_APP_ENV === 'dev' || process.env.NX_APP_ENV === 'staging'
      ? 'TEST676947319331685867'
      : 'GM656681123055508236'
};

// 核酸检测支付中台商户ID
export const Covid19Info = ConsultInfo;

export const CANCEL_CONSULT_TIPS = '（取消后，健康咨询费用将原路返回）';
// 取消预约提示语
export const CANCEL_REGISTER_TIPS = '退号后此次挂号将不再有效';

export const COVID_APPOINTMENT_NOTICE = [
  '1、核酸检测采样前两小时尽量不进食;前三十分钟不喝水、不吸烟、不嚼口香糖;排队保持一米以上间距;临检时,减少吞咽,不做清嗓子动作;采样后立即离开。',
  '2、为避免到场后无法检测,请先购买并完成在线预约,预约完成后会收到橄榄枝健康预约成功短信,需要按照橄榄枝健康预约成功短信日期及时段前往检测（注意短信发送的预约码及时间）',
  '3、检测人员须持有效证件按照预约时间前往机构检查, 因机构均为检测实验室核酸检测采样点, 无法接待去过中高风险地区客户及健康码不是绿码的客户, 烦请提前确认情况以免无法检测。',
  '4、被检测者要求戴口罩, 同时准备一个新的备用口罩。',
  '5、检测时请按照医院规定执行, 待检时请与人保持1米以上距离，尽量减少交谈。',
  '6、接收咽拭子采样时按照医生规定取下口罩进行检测, 取咽拭子的过程并不长, 但当拭子深入喉咙深处, 可能会有稍许恶心和不适感, 采样完症状消失。',
  '7、采集完样品后立即洗手或用免洗酒精擦拭双手, 戴上备用口罩, 并将废弃口罩投入指定医用垃圾桶中。',
  '8、检测确认完成后尽快离开医院, 勿在检查去逗留。'
];

// 挂号按医院搜索时医院等级筛选依据

// 医院等级筛选
export const HospitalLevelOptions: IPickerOption[] = [
  { value: '0', text: '不限' },
  { value: '1', text: '三甲' },
  { value: '2', text: '三乙' },
  { value: '3', text: '三丙' },
  { value: '4', text: '二甲' },
  { value: '5', text: '二乙' },
  { value: '6', text: '二丙' },
  { value: '7', text: '一甲' },
  { value: '8', text: '一乙' },
  { value: '9', text: '一丙' },
  { value: '10', text: '其他' },
  { value: '11', text: '一级' },
  { value: '12', text: '二级' },
  { value: '13', text: '三级' }
];

// 推荐医生列表埋点上报事件key
export const BUTTON_NAME = new Map([
  [PRODUCT_TYPE.Message, 'PICTURE'],
  [PRODUCT_TYPE.Call, 'PHONE'],
  [PRODUCT_TYPE.QuickConsult, 'CONSULT'],
  [PRODUCT_TYPE.SkinConsult, 'SkinConsult']
]);

export const AGE_LIST = new Array(120).fill(1).map((item, index) => {
  return {
    label: `${item + index}岁`,
    value: item + index
  };
});

export const BEIJING_LOCATION = {
  latitude: 39.92,
  longitude: 116.46
};

export const IM_COMMON_CONFIG = {
  sid: 'kuaishou.midground.api',
  kpn: 'KUAISHOU.healthy',
  subBiz: 'Channel_Healthy', // 单聊
  subBizGroup: 'Channel_Healthy_Group' // 群聊
};
